module.exports = __webpack_public_path__ + "img/powerful_dashboard.252e2d64.png";